"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _pagination = require("./pagination");
Object.keys(_pagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pagination[key];
    }
  });
});
//# sourceMappingURL=index.js.map